export default __webpack_public_path__ + "static/media/dwellsocial_logo_regular_reverse.9a8c247c.svg";